import { ShippingTime } from '@app/models/shipping-time';
import { Action } from '@ngrx/store';

export enum ShippingTimeActionTypes {
  Load = '[API] Load shipping times',
  LoadSuccess = '[API] Load shipping times success',
  LoadFail = '[API] Load shipping times fail',
  AddOne = '[ShippingTime] Add one',
  AddAll = '[ShippingTime] Add all',
  Create = '[API] Create shipping time',
  CreateSuccess = '[API] Create shipping time success',
  CreateFail = '[API] Create shipping time fail',

  Export = '[API] export shipping time',
  ExportSuccess = '[API] export shipping time success',
  ExportFail = '[API] export shipping time fail',
  
  UploadSuccess = '[API] upload shipping time success',
  RefreshShippingTimes = '[API] refresh shipping time',
  RefreshShippingTimesSuccess = '[API] refresh shipping time success',
  RefreshShippingTimesFail = '[API] refresh shipping time fail'
}

export class Load implements Action {
  readonly type = ShippingTimeActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = ShippingTimeActionTypes.LoadSuccess;
  constructor(public shippingTimes: ShippingTime[]) {}
}

export class LoadFail implements Action {
  readonly type = ShippingTimeActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Export implements Action {
  readonly type = ShippingTimeActionTypes.Export;
  constructor() {}
}

export class ExportSuccess implements Action {
  readonly type = ShippingTimeActionTypes.ExportSuccess;
  constructor() {}
}

export class UploadSuccess implements Action {
  readonly type = ShippingTimeActionTypes.UploadSuccess;
  constructor(public data: any) {}
}

export class ExportFail implements Action {
  readonly type = ShippingTimeActionTypes.ExportFail;
  constructor(public error: any) {}
}

export class RefreshShippingTimes implements Action {
  readonly type = ShippingTimeActionTypes.RefreshShippingTimes;
  constructor() {}
}

export class RefreshShippingTimesSuccess implements Action {
  readonly type = ShippingTimeActionTypes.RefreshShippingTimesSuccess;
  constructor() {}
}

export class RefreshShippingTimesFail implements Action {
  readonly type = ShippingTimeActionTypes.RefreshShippingTimes;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = ShippingTimeActionTypes.Create;
  constructor(public shippingTime: ShippingTime) {}
}

export class CreateSuccess implements Action {
  readonly type = ShippingTimeActionTypes.CreateSuccess;
  constructor(public shippingTime: ShippingTime) {}
}

export class CreateFail implements Action {
  readonly type = ShippingTimeActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = ShippingTimeActionTypes.AddOne;
  constructor(public shippingTime: ShippingTime) {}
}

export class AddAll implements Action {
  readonly type = ShippingTimeActionTypes.AddAll;
  constructor(public shippingTimes: ShippingTime[]) {}
}

export type ShippingTimeActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Export
  | ExportSuccess
  | UploadSuccess
  | ExportFail
  | RefreshShippingTimes
  | RefreshShippingTimesSuccess
  | RefreshShippingTimesFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddAll
  | AddOne;
